<template>
  <body class="content-body">
    <PartnersProgram />
    <ForBrands />
    <WhyPartner />
    <ProgramBenefits />
    <JoinTheProgram
      highlightText="Join the Wecobi Partner Program"
      mainText="today, and take the first step toward a future where sustainability and profitability go hand in hand. Together, we can reduce waste, increase your brand's impact, and grow your business responsibly."
    />
    <ForInfluencers />
    <WhyPartnerTwo />
    <ProgramBenefitsTwo />
    <JoinTheProgram
      highlightText="Join the Wecobi Influencer Partner Program"
      mainText="today, and be a part of a movement that combines sustainability with influence and profitability. Together, we can inspire positive change and help brands succeed responsibly."
    />
  </body>
</template>

<script>
import PartnersProgram from "../Company/CompanyContent/PartnersProgram.vue";
import ForBrands from "./PartnershipProgramContent/ForBrands.vue";
import WhyPartner from "./PartnershipProgramContent/WhyPartner.vue";
import ProgramBenefits from "./PartnershipProgramContent/ProgramBenefits.vue";
import JoinTheProgram from "./SharedComponents/JoinTheProgram.vue";
import ForInfluencers from "./PartnershipProgramContent/ForInfluencers.vue";
import WhyPartnerTwo from "./PartnershipProgramContent/WhyPartnerTwo.vue";
import ProgramBenefitsTwo from "./PartnershipProgramContent/ProgramBenefitsTwo.vue";

export default {
  name: "PartnershipProgramContent",
  components: {
    PartnersProgram,
    ForBrands,
    WhyPartner,
    ProgramBenefits,
    JoinTheProgram,
    ForInfluencers,
    WhyPartnerTwo,
    ProgramBenefitsTwo,
  },
};
</script>

<style scoped>
.content-body {
  padding: 29px 34px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 744px) {
  .content-body {
    padding: 21px 17px;
    gap: 16px;
  }
}
</style>
